import { Box, Divider, Grid, makeStyles, Typography } from '@material-ui/core'
import React, { useState } from 'react'
import EditIcon from '@material-ui/icons/Edit';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useHistory } from 'react-router';
import { useEffect } from 'react';
import { fetchSla } from './redux/SlaService';
import SLAModal from './SLAModal';
import { Button } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    toggleBtn: {
        backgroundColor: "#fff",
        color: "#4089FC",
        border: "1px solid #00808080",
        padding: "5px 10px",
        borderRadius: "5px 0px 0px 5px",
        "& + $toggleBtn": {
            borderRadius: "0px 5px 5px 0px"
        },

        "&.active": {
            backgroundColor: "#00808080",
            color: "#fff"
        }
    },
    large: {
        width: theme.spacing(13),
        height: theme.spacing(13),
    },
}));

interface ICurrentSelection {
    attention_status: string
    coach_name: string
    coachee_image: string
    coachee_name: string
    date_received: string | null
    id: number
    location: string
    programme_type: string
    tableData: any
    title: string
    unit: string
};

interface IProps {
    history: any,
    location: {
        hash: string
        key: string
        pathname: string
        search: string,
        state: {
            currentAssignment: ICurrentSelection
        }
    },
    match: any,
    staticContext: any
};

interface ISlaData {
    description: string
    exceptional_circumstances: string
    exceptions: string
    measure: string
    measure_meet: string
    measure_meet_percentage: string
    org_sla_id: number
};

const Sla: React.FC<IProps> = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const history: any = useHistory();
    const location: any = useLocation();
    const getSlaData = useSelector((state: any) => state?.SLA);

    const [SLAModalFlag, setSLAModalFlag] = useState<boolean>(false);
    const [currentRowSelection, setCurrentRowSelection] = useState<any>(undefined);
    const [labelFlag, setLabelFlag] = useState<string>("");

    useEffect(() => {
        let param = {
            assignment_id: location?.state?.currentAssignment?.id
        };
        dispatch(fetchSla(param));
    }, [dispatch]);

    return <Box py={3}>
        <Grid container direction="row" alignItems="center" style={{ marginTop: 20, borderWidth: 1, borderColor: "#ddd", borderStyle: "solid", padding: 16 }}>
            <Grid item xs={2}>
                <Typography variant="h2" style={{ color: "#4a4a4a" }}>
                    <Box fontWeight="fontWeightBold">Description</Box>
                </Typography>
            </Grid>
            <Grid item xs={2} >
                <Typography variant="h2" style={{ color: "#4a4a4a" }}>
                    <Box fontWeight="fontWeightBold">Measure</Box>
                </Typography>
            </Grid>
            <Grid item xs={3}>
                <Typography variant="h2" style={{ color: "#4a4a4a" }}>
                    <Box fontWeight="fontWeightBold">Did we meet the measure?</Box>
                </Typography>
            </Grid>
            <Grid item xs={2}>
                <Typography variant="h2" style={{ color: "#4a4a4a" }}>
                    <Box fontWeight="fontWeightBold">Were there exceptional circumstances?</Box>
                </Typography>
            </Grid>
            <Grid item xs={2}>
                <Typography variant="h2" style={{ color: "#4a4a4a" }}>
                    <Box fontWeight="fontWeightBold">Exceptions</Box>
                </Typography>
            </Grid>
            <Grid item xs={1}>
                <Typography variant="h2" style={{ color: "#4a4a4a" }}>
                    <Box fontWeight="fontWeightBold">Edit</Box>
                </Typography>
            </Grid>
        </Grid>
        <Box>
            {
                getSlaData?.SLAData?.SLA_details?.map((option: ISlaData) => {
                    return <>
                        <Grid container direction="row" alignItems="center" style={{ borderWidth: 1, borderColor: "#ddd", borderStyle: "solid", padding: 16 }}>
                            <Grid item xs={2}>
                                <Typography variant="h2" style={{ color: "#232323", paddingRight: "40px", textAlign: "left" }}>
                                    <Box >{option?.description}</Box>
                                </Typography>
                            </Grid>
                            <Grid item xs={2}>
                                <Typography variant="h2" style={{ color: "#232323", paddingRight: "40px", textAlign: "left" }}>
                                    <Box >{option?.measure}</Box>
                                </Typography>
                            </Grid>
                            <Grid item xs={3} alignContent="center" >
                                <Grid item xs={12} style={{paddingLeft:40}}>
                                    <Box>
                                        <Box component="span" className={classes.toggleBtn} style={{
                                            backgroundColor: option?.measure_meet == 'true' ? "rgb(7,121,131)" : "#fff",
                                            color: option?.measure_meet == 'true' ? "#fff" : "rgb(7,121,131)"
                                        }}>Yes</Box>
                                        <Box component="span" className={classes.toggleBtn} style={{
                                            backgroundColor: option?.measure_meet == 'false' || option?.measure_meet == '' ? "rgb(7,121,131)" : "#fff",
                                            color: option?.measure_meet == 'false' || option?.measure_meet == '' ? "#fff" : "rgb(7,121,131)"
                                        }}>No</Box>
                                    </Box>
                                </Grid>
                            </Grid>
                            <Grid item xs={2}>
                                <Typography variant="h2" style={{ color: "#232323" }}>
                                    <Grid item xs={12} style={{paddingLeft:10}}>
                                        <Box>
                                            <Box component="span" className={classes.toggleBtn} style={{
                                                backgroundColor: option?.exceptional_circumstances == 'true' ? "rgb(7,121,131)" : "#fff",
                                                color: option?.exceptional_circumstances == 'true' ? "#fff" : "rgb(7,121,131)"
                                            }}>Yes</Box>
                                            <Box component="span" className={classes.toggleBtn} style={{
                                                backgroundColor: option?.exceptional_circumstances == 'false' || option?.exceptional_circumstances === '' ? "rgb(7,121,131)" : "#fff",
                                                color: option?.exceptional_circumstances == 'false' || option?.exceptional_circumstances === '' ? "#fff" : "rgb(7,121,131)"
                                            }}>No</Box>
                                        </Box>
                                    </Grid>
                                </Typography>
                            </Grid>
                            <Grid item xs={2}>
                                <Typography variant="h2" style={{ color: "#232323" }}>
                                    <Box >
                                        <Button style={{ textTransform: 'none', paddingLeft:30 }} color="primary" onClick={() => {
                                            setLabelFlag("viewExceptionsDetail");
                                            setCurrentRowSelection(option);
                                            setSLAModalFlag(true);
                                        }}>
                                            View details
                                        </Button>
                                    </Box>
                                </Typography>
                            </Grid>
                            <Grid item xs={1}>
                                <Typography variant="h2" style={{ color: "#232323" }}>
                                    <Box onClick={() => {
                                        setLabelFlag("editAssignmentSummary");
                                        setCurrentRowSelection(option);
                                        setSLAModalFlag(true);
                                    }}>
                                        <EditIcon style={{ color: "#757575", cursor: 'pointer',paddingLeft:15 }} />
                                    </Box>
                                </Typography>
                            </Grid>
                        </Grid>
                        <Divider />
                    </>
                })
            }
        </Box>

        {SLAModalFlag && labelFlag == 'editAssignmentSummary' &&
            <SLAModal {...props} labelFlag={labelFlag} currentRowSelection={currentRowSelection}
                isOpen={SLAModalFlag}
                onClose={() => {
                    setSLAModalFlag(false)
                }} />}

        {SLAModalFlag && labelFlag == "viewExceptionsDetail" &&
            <SLAModal {...props} labelFlag={labelFlag} currentRowSelection={currentRowSelection} isOpen={SLAModalFlag}
                onClose={() => {
                    setSLAModalFlag(false)
                }} />}
    </Box>
}

export default Sla
